module.exports = __webpack_public_path__ + "img/facebook.ac1dab8c.svg";